import { message } from 'antd';
import { toLonLat, transform } from 'ol/proj';
//@ts-ignore
import pako from 'pako';
import { updateNode, fetchNodesBySiteAndFloor } from '../../../store/nodesSlice';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import GeoJSON from 'ol/format/GeoJSON';
import { Style, Fill, Stroke } from 'ol/style';
export const saveShape = (jsonData, socket) => {
    let filteredJsonData = JSON.parse(jsonData);
    if (filteredJsonData?.properties?.geometry) {
        delete filteredJsonData?.properties?.geometry;
    }
    return new Promise((resolve, reject) => {
        try {
            const parsedData = filteredJsonData;
            // const message = { jsonData: parsedData };
            const byteArray = JSON.stringify(parsedData);
            const data = pako.gzip(byteArray);
            const message = { jsonData: data };
            // Emit the shape data to the server
            socket.emit('SAVE_SHAPE', message);
            // // Listen for the specific response containing the shape ID
            socket.on('SAVE_SHAPE', (data) => {
                if (data && data.data) {
                    const slicedData = data?.data?.slice(1);
                    try {
                        const compressedData = pako.ungzip(slicedData, { to: 'string' });
                        const shapeResponse = JSON.parse(compressedData);
                        const shapeId = shapeResponse?.feature?.properties?.shapeId;
                        resolve(shapeId);
                    }
                    catch (error) {
                    }
                }
            });
        }
        catch (e) {
            console.error('Invalid JSON data');
            reject(e);
        }
    });
};
export const onPropertiesChange = async (values, selectedFeatures, socket, callback, setRouteCollection, routeLayerRef, dispatch, siteId, selectedKeys) => {
    let payload = { ...values };
    // Convert color properties to hexadecimal strings if they exist
    if (payload?.color && typeof payload?.color === 'object')
        payload.color = payload?.color?.toHexString();
    if (payload?.fillColor && typeof payload?.fillColor === 'object')
        payload.fillColor = payload?.fillColor?.toHexString();
    if (payload?.hoverColor && typeof payload?.hoverColor === 'object') {
        payload.hoverColor = payload?.hoverColor?.toHexString();
    }
    if (payload?.labelColor && typeof payload?.labelColor === 'object')
        payload.labelColor = payload?.labelColor?.toHexString();
    const selectedPolygon = selectedFeatures;
    const shapeType = selectedPolygon.getProperties()?.type;
    let shapeProperties = {};
    if (shapeType === 'POLYGON' || shapeType === 'CIRCLE') {
        shapeProperties = {
            ...(payload.labelColor || payload.align || payload.fontFamily || payload.fontSize || payload.position || payload.nextRotation
                ? {
                    label: {
                        ...(payload.labelColor && {
                            labelColor: payload.labelColor,
                        }),
                        ...(payload.align && { align: payload.align }),
                        ...(payload.fontFamily && {
                            fontFamily: payload.fontFamily,
                        }),
                        ...(payload.fontSize && {
                            fontSize: payload.fontSize,
                        }),
                        ...(payload.position && {
                            position: payload.position,
                        }),
                        ...(payload.nextRotation && {
                            nextRotation: payload.nextRotation,
                        }),
                    },
                }
                : {}),
            ...(payload.height && { height: payload.height }),
            ...(payload.opacity && { opacity: payload.opacity }),
            ...(payload.hoverColor && {
                hoverColor: payload.hoverColor,
            }),
            ...(payload.color && { color: payload.color }),
        };
    }
    else if (shapeType === 'WALL') {
        shapeProperties = {
            ...(payload.height && { height: payload.height }),
            ...(payload.opacity && { opacity: payload.opacity }),
            ...(payload.hoverColor && {
                hoverColor: payload.hoverColor,
            }),
            ...(payload.color && { color: payload.color }),
            ...(payload.fillColor && { fillColor: payload.fillColor }),
        };
    }
    else if (shapeType === 'INNER_WALL') {
        shapeProperties = {
            ...(payload.height && { height: payload.height }),
            ...(payload.opacity && { opacity: payload.opacity }),
            ...(payload.color && { color: payload.color }),
        };
    }
    else if (selectedFeatures.getGeometry().getType() === 'Point') {
        console.log(payload, "payload");
        // Update node properties via API if dispatch and required parameters are provided
        if (dispatch && siteId && selectedKeys && selectedKeys.length > 0) {
            const nodeId = selectedFeatures.getProperties()?.nodeId;
            if (nodeId) {
                try {
                    const updateData = {};
                    if (payload.accessible !== undefined)
                        updateData.accessible = payload.accessible;
                    if (payload.private !== undefined)
                        updateData.privateNode = payload.private;
                    if (payload.description !== undefined)
                        updateData.description = payload.description;
                    if (Object.keys(updateData).length > 0) {
                        await dispatch(updateNode({
                            siteId,
                            nodeId,
                            data: updateData
                        }));
                        message.success('Node properties updated successfully');
                        // Refresh nodes data after successful update
                        await dispatch(fetchNodesBySiteAndFloor({
                            siteId,
                            floorId: selectedKeys[0]
                        }));
                    }
                    // Call callback to close the modal
                    callback && callback();
                }
                catch (error) {
                    console.error('Error updating node properties:', error);
                    message.error('Error updating node properties');
                    // Call callback even on error to close the modal
                    callback && callback();
                }
            }
        }
        // Call callback to close the modal for Point geometry (even if no API call was made)
        callback && callback();
    }
    else if (shapeType === "route") {
        selectedPolygon.setProperties({
            ...selectedPolygon.getProperties(),
            ...(payload.direction !== undefined && { direction: payload.direction })
        });
        // Update route collection for route shapes
        if (setRouteCollection && routeLayerRef?.current) {
            setTimeout(() => {
                const geoJsonRoute = getGeoJson(routeLayerRef.current.getSource());
                setRouteCollection(removeDuplicateFeatures(geoJsonRoute));
            }, 100);
        }
        message.success('Route direction updated successfully');
        callback && callback();
        return;
    }
    if (selectedPolygon && selectedPolygon.getGeometry().getType() === 'Polygon') {
        selectedPolygon.setProperties({
            ...selectedPolygon.getProperties(),
            shapeProperties, // Assign the updated shape properties based on shapeType
        });
        const geometry = selectedPolygon.getGeometry();
        const coordinates = geometry
            .getCoordinates()
            .map((ring) => ring.map((coord) => transform(coord, 'EPSG:3857', 'EPSG:4326')));
        const geojsonFeature = {
            type: 'Feature',
            properties: {
                ...selectedPolygon.getProperties(),
                shapeProperties,
            },
            geometry: {
                type: 'Polygon',
                coordinates: coordinates,
            },
        };
        try {
            await saveShape(JSON.stringify(geojsonFeature, null, 2), socket);
            socket.emit('UPDATE_SHAPE', geojsonFeature);
            message.success('Properties added successfully');
            callback && callback();
            //   setSelectedFeatures(null);
        }
        catch (error) {
            console.error('Error saving shape:', error);
            message.error('Error saving shape');
        }
    }
    else if (selectedPolygon && selectedPolygon.getGeometry().getType() === 'Circle') {
        const center = selectedPolygon?.getGeometry().getCenter();
        const radius = selectedPolygon?.getGeometry().getRadius();
        selectedPolygon.setProperties({
            ...selectedPolygon.getProperties(),
            shapeProperties, // Assign the updated shape properties based on shapeType
        });
        const geojsonFeature = {
            type: 'Feature',
            properties: {
                ...selectedPolygon.getProperties(),
                shapeProperties,
                radius,
            },
            geometry: {
                type: 'Point',
                coordinates: transform(center, 'EPSG:3857', 'EPSG:4326'),
            },
        };
        try {
            await saveShape(JSON.stringify(geojsonFeature, null, 2), socket);
            socket.emit('UPDATE_SHAPE', geojsonFeature);
            message.success('Properties added successfully');
            callback && callback();
            //   setSelectedFeatures(null);
        }
        catch (error) {
            console.error('Error saving shape:', error);
            message.error('Error saving shape');
        }
    }
    if (selectedPolygon && selectedPolygon.getGeometry()?.getType() === 'LineString' && shapeType !== "route") {
        const coordinates = selectedPolygon
            .getGeometry()
            .getCoordinates()
            .map((coord) => transform(coord, 'EPSG:3857', 'EPSG:4326'));
        shapeProperties = {
            ...(payload.height && { height: payload.height }),
            ...(payload.opacity && { opacity: payload.opacity }),
            ...(payload.color && { color: payload.color }),
        };
        selectedPolygon.setProperties({
            ...selectedPolygon.getProperties(),
            shapeProperties, // Assign the updated shape properties based on shapeType
        });
        const geojsonFeature = {
            type: 'Feature',
            properties: {
                ...selectedPolygon.getProperties(),
                shapeProperties,
            },
            geometry: {
                type: 'LineString',
                coordinates,
            },
        };
        try {
            await saveShape(JSON.stringify(geojsonFeature, null, 2), socket);
            socket.emit('UPDATE_SHAPE', geojsonFeature);
            message.success('Properties added successfully');
            callback && callback();
        }
        catch (error) {
            console.error('Error saving shape:', error);
            message.error('Error saving shape');
        }
    }
};
export const saveRouteData = (dataSite, socket, pointLayerRef, setNodesData, setRouteFlag, dispatch) => {
    setRouteFlag(true);
    const byteArray = JSON.stringify(dataSite);
    const zippedData = pako.gzip(byteArray);
    const messageToSocket = { jsonData: zippedData };
    // Emit the message to the socket
    socket.emit('CREATE_OR_UPDATE_ROUTE', messageToSocket);
    // Listen for the response from the socket
    socket.on('CREATE_OR_UPDATE_ROUTE', (data) => {
        const slicedData = data?.data?.slice(1);
        const compressedData = pako.ungzip(slicedData, { to: 'string' });
        const routeResponse = JSON.parse(compressedData);
        if (data && data.data) {
            const slicedData = data?.data?.slice(1);
            try {
                // Decompress the data
                const compressedData = pako.ungzip(slicedData, { to: 'string' });
                const routeResponse = JSON.parse(compressedData);
                // Extract nodes from routeResponse
                const { nodes } = routeResponse;
                // Access the source of pointLayer
                const pointSource = pointLayerRef.current.getSource();
                // Iterate over each feature in pointLayer
                pointSource.getFeatures().forEach((pointFeature) => {
                    const [lng, lat] = toLonLat(pointFeature.getGeometry().getCoordinates());
                    // Find matching node based on lat and lng
                    const matchingNode = nodes.find((node) => node.lat === lat && node.lng === lng);
                    // If a matching node is found, update the point feature's properties
                    if (matchingNode) {
                        pointFeature.setProperties({
                            ...pointFeature.getProperties(),
                            nodeId: matchingNode.nodeId,
                            floorId: matchingNode.floorId,
                            siteId: matchingNode.siteId,
                            accessible: matchingNode.accessible,
                            privateNode: matchingNode.privateNode,
                            siblings: matchingNode.siblings,
                            type: "none"
                        });
                    }
                });
                message.success('Route Saved');
                // Call fetchNodesBySiteAndFloor API to refresh nodes data
                if (dispatch && dataSite?.siteId && dataSite?.floorId) {
                    dispatch(fetchNodesBySiteAndFloor({
                        siteId: dataSite.siteId,
                        floorId: dataSite.floorId
                    }));
                }
                socket.emit('GET_ROUTE', {
                    floorId: dataSite?.floorId,
                    siteId: dataSite?.siteId,
                });
                socket.on('GET_ROUTE', (data) => {
                    if (data && data.data) {
                        const slicedData = data?.data?.slice(1);
                        try {
                            const compressedData = pako.ungzip(slicedData, {
                                to: 'string',
                            });
                            const shapeResponse = JSON.parse(compressedData);
                            if (shapeResponse?.floorId === dataSite?.floorId) {
                                setNodesData(shapeResponse);
                            }
                        }
                        catch (error) {
                        }
                    }
                });
                socket.off('CREATE_OR_UPDATE_ROUTE');
                setRouteFlag(false);
            }
            catch (error) {
                message.error('Something went wrong');
                socket.off('CREATE_OR_UPDATE_ROUTE');
                setRouteFlag(false);
            }
        }
        else {
            setRouteFlag(false);
            message.error('Something went wrong');
        }
    });
};
export function findTitle(key, tree) {
    for (const node of tree) {
        if (node.key === key) {
            return {
                title: node?.title,
                rotation: node?.floorData?.rotation,
            };
        }
        if (node.children) {
            const childResult = findTitle(key, node.children);
            if (childResult)
                return childResult;
        }
    }
    return null;
}
// Robust duplicate removal for features with exact coordinate matching
export function removeDuplicateFeatures(geojson) {
    if (!geojson?.features || !Array.isArray(geojson.features)) {
        return geojson;
    }
    const uniqueFeatures = [];
    const seenCoordinates = new Set();
    for (let i = 0; i < geojson.features.length; i++) {
        const feature = geojson.features[i];
        if (!feature?.geometry?.coordinates) {
            continue;
        }
        // Create exact coordinate string for precise duplicate detection
        const coordinatesString = JSON.stringify(feature.geometry.coordinates);
        if (!seenCoordinates.has(coordinatesString)) {
            seenCoordinates.add(coordinatesString);
            uniqueFeatures.push(feature);
        }
    }
    return {
        ...geojson,
        features: uniqueFeatures,
    };
}
// Remove duplicate features directly from layer source
export function removeDuplicatesFromSource(source) {
    if (!source) {
        return 0;
    }
    const allFeatures = source.getFeatures();
    if (!allFeatures || allFeatures.length === 0) {
        return 0;
    }
    const seenCoordinates = new Set();
    const duplicatesToRemove = [];
    for (const feature of allFeatures) {
        const geometry = feature.getGeometry();
        if (!geometry) {
            continue;
        }
        const coordinates = geometry.getCoordinates();
        const coordinatesString = JSON.stringify(coordinates);
        if (seenCoordinates.has(coordinatesString)) {
            duplicatesToRemove.push(feature);
        }
        else {
            seenCoordinates.add(coordinatesString);
        }
    }
    // Remove duplicates from source
    duplicatesToRemove.forEach(feature => {
        source.removeFeature(feature);
    });
    return duplicatesToRemove.length;
}
// Adds unique point features for each vertex of the line strings in lineStringFeatures to the pointLayerRef
export function updatePointsToVertices(lineStringFeatures, pointLayerRef, selectedLayerData) {
    const pointFeatures = [];
    const uniqueIds = new Set();
    // Get existing point features from pointLayer
    if (!pointLayerRef.current || !pointLayerRef.current.getSource())
        return;
    const existingPointFeatures = pointLayerRef.current.getSource().getFeatures();
    const existingCoordinates = new Set(existingPointFeatures
        .map((feature) => {
        const geometry = feature.getGeometry();
        if (!geometry)
            return null;
        const [lng, lat] = toLonLat(geometry.getCoordinates());
        return `point_${lat}_${lng}`;
    })
        .filter((id) => id !== null));
    lineStringFeatures?.forEach((feature) => {
        const geometry = feature?.getGeometry();
        if (geometry && geometry.getType() === 'LineString') {
            const coordinates = geometry.getCoordinates();
            coordinates?.forEach((coordinate) => {
                const [lng, lat] = toLonLat(coordinate);
                const pointId = `point_${lat}_${lng}`;
                // Check if this point already exists in pointLayer
                if (!existingCoordinates.has(pointId) && !uniqueIds.has(pointId)) {
                    uniqueIds.add(pointId);
                    const pointFeature = new Feature({
                        geometry: new Point(coordinate),
                    });
                    pointFeature.setProperties({
                        ...pointFeature.getProperties(),
                        layerId: selectedLayerData?.layerId, // Assign layerId from selectedLayerData
                    });
                    pointFeatures.push(pointFeature);
                }
            });
        }
    });
    // Add new point features to pointLayer
    if (pointLayerRef.current && pointLayerRef.current.getSource()) {
        pointLayerRef.current.getSource().addFeatures(pointFeatures);
    }
}
// Performance optimized: Get GeoJSON with caching and batching
export function getGeoJson(source) {
    if (!source)
        return { type: 'FeatureCollection', features: [] };
    const features = source.getFeatures();
    if (!features || features.length === 0) {
        return { type: 'FeatureCollection', features: [] };
    }
    // Performance optimization: Process features in batches for large datasets
    const batchSize = 200;
    const format = new GeoJSON();
    const allFeatures = [];
    for (let i = 0; i < features.length; i += batchSize) {
        const batch = features.slice(i, i + batchSize);
        try {
            const geoJsonStr = format.writeFeatures(batch, {
                dataProjection: 'EPSG:4326',
                featureProjection: 'EPSG:3857',
            });
            const batchResult = JSON.parse(geoJsonStr);
            allFeatures.push(...batchResult.features);
        }
        catch (error) {
            console.warn('Error processing feature batch:', error);
            // Continue with next batch
        }
    }
    return {
        type: 'FeatureCollection',
        features: allFeatures,
    };
}
// Generate unique ID for features
export const generateUniqueId = () => `id-${Date.now()}`;
// Performance optimized: Transform coordinates with batching
export const transformCoordinates = (geometry) => {
    const geometryType = geometry.getType();
    if (geometryType === 'Polygon') {
        const coordinates = geometry.getCoordinates();
        return coordinates.map((ring) => transformCoordinateBatch(ring));
    }
    else if (geometryType === 'LineString') {
        const coordinates = geometry.getCoordinates();
        return transformCoordinateBatch(coordinates);
    }
    else if (geometryType === 'Circle') {
        return transform(geometry.getCenter(), 'EPSG:3857', 'EPSG:4326');
    }
    return null;
};
// Performance helper: Batch transform coordinates for better performance
function transformCoordinateBatch(coordinates) {
    const batchSize = 100;
    const result = [];
    for (let i = 0; i < coordinates.length; i += batchSize) {
        const batch = coordinates.slice(i, i + batchSize);
        const transformedBatch = batch.map((coord) => transform(coord, 'EPSG:3857', 'EPSG:4326'));
        result.push(...transformedBatch);
    }
    return result;
}
// Get default shape properties based on geometry type
export const getDefaultShapeProperties = (geometryType) => {
    const baseProperties = {
        color: '#F7F7F7',
        height: 0,
        opacity: 1,
    };
    const extendedProperties = {
        ...baseProperties,
        hoverColor: '#FFFFFF',
        label: {
            align: 'top-left',
            fontFamily: 'Arial, sans-serif',
            fontSize: 10,
            labelColor: '#FFFFFF',
        },
    };
    switch (geometryType) {
        case 'POLYGON':
            return {
                color: '#FFFFFF',
                height: 4,
                hoverColor: '#FFFFFF',
                label: {
                    align: 'top-left',
                    fontFamily: 'Arial, sans-serif',
                    fontSize: 10,
                    labelColor: '#FFFFFF',
                },
                opacity: 1,
            };
        case 'INNER_WALL':
            return baseProperties;
        default:
            return extendedProperties;
    }
};
// Create GeoJSON feature from OpenLayers feature
export const createGeoJSONFromFeature = (feature) => {
    const properties = feature.getProperties();
    const geometry = feature.getGeometry();
    const olGeometryType = geometry.getType();
    if (olGeometryType === 'Polygon') {
        const coordinates = transformCoordinates(geometry);
        return {
            type: 'Feature',
            properties: {
                type: properties?.type,
                floorId: properties?.floorId,
                siteId: properties?.siteId,
                id: properties?.id,
                shapeId: properties?.shapeId,
                layerId: properties?.layerId,
                shapeProperties: properties?.shapeProperties,
            },
            geometry: {
                type: 'Polygon',
                coordinates: coordinates,
            },
        };
    }
    else if (olGeometryType === 'LineString') {
        const coordinates = transformCoordinates(geometry);
        return {
            type: 'Feature',
            properties: {
                type: properties?.type,
                floorId: properties?.floorId,
                siteId: properties?.siteId,
                id: properties?.id,
                shapeId: properties?.shapeId,
                layerId: properties?.layerId,
                shapeProperties: properties?.shapeProperties,
            },
            geometry: {
                type: 'LineString',
                coordinates: coordinates,
            },
        };
    }
    else if (olGeometryType === 'Circle') {
        const center = transformCoordinates(geometry);
        const radius = geometry.getRadius();
        return {
            type: 'Feature',
            properties: {
                type: properties?.type,
                floorId: properties?.floorId,
                siteId: properties?.siteId,
                id: properties?.id,
                shapeId: properties?.shapeId,
                layerId: properties?.layerId,
                shapeProperties: properties?.shapeProperties,
                radius: radius,
            },
            geometry: {
                type: 'Point',
                coordinates: center,
            },
        };
    }
    return null;
};
// Save shape with error handling
export const saveShapeWithErrorHandling = async (geojsonFeature, feature, socket) => {
    try {
        const shapeId = await saveShape(JSON.stringify(geojsonFeature, null, 2), socket);
        feature.setProperties({
            ...feature.getProperties(),
            shapeId: shapeId,
        });
        return shapeId;
    }
    catch (error) {
        console.error('Error saving shape:', error);
        message.error('Error saving shape');
        throw error;
    }
};
// ==================== DRAW END HANDLERS ====================
// Handle polygon draw end (auto-save enabled)
export const handlePolygonDrawEnd = async (event, geometryType, selectedKeys, siteId, selectedLayerData, socket) => {
    const feature = event.feature;
    const uniqueId = generateUniqueId();
    const geometry = feature.getGeometry();
    const coordinates = transformCoordinates(geometry);
    const shapeProperties = getDefaultShapeProperties(geometryType);
    // Set feature properties
    feature.setProperties({
        type: geometryType,
        floorId: selectedKeys?.join(''),
        siteId: siteId,
        id: uniqueId,
        layerId: selectedLayerData?.layerId,
        shapeProperties,
    });
    // Create GeoJSON for saving
    const geojsonFeature = {
        type: 'Feature',
        properties: {
            type: geometryType,
            floorId: selectedKeys?.join(''),
            siteId: siteId,
            id: uniqueId,
            layerId: selectedLayerData?.layerId,
            shapeProperties,
        },
        geometry: {
            type: 'Polygon',
            coordinates: coordinates,
        },
    };
    // Auto-save the shape
    await saveShapeWithErrorHandling(geojsonFeature, feature, socket);
};
// Handle circle draw end (auto-save enabled)
export const handleCircleDrawEnd = async (event, selectedKeys, siteId, selectedLayerData, socket) => {
    const feature = event.feature;
    const circle = feature.getGeometry();
    const center = circle.getCenter();
    const radius = circle.getRadius();
    const transformedCenter = toLonLat(center);
    const uniqueId = generateUniqueId();
    const shapeProperties = getDefaultShapeProperties('CIRCLE');
    // Set feature properties
    feature.setProperties({
        type: 'CIRCLE',
        floorId: selectedKeys?.join(''),
        siteId: siteId,
        id: uniqueId,
        layerId: selectedLayerData?.layerId,
        shapeProperties,
    });
    // Create GeoJSON for saving
    const geojsonFeature = {
        type: 'Feature',
        properties: {
            type: 'CIRCLE',
            floorId: selectedKeys?.join(''),
            siteId: siteId,
            id: uniqueId,
            layerId: selectedLayerData?.layerId,
            radius: radius,
            shapeProperties,
        },
        geometry: {
            type: 'Point',
            coordinates: transformedCenter,
        },
    };
    // Auto-save the shape
    await saveShapeWithErrorHandling(geojsonFeature, feature, socket);
};
// Handle line string draw end (auto-save enabled)
export const handleLineStringDrawEnd = async (event, geometryType, selectedKeys, siteId, selectedLayerData, socket) => {
    const feature = event.feature;
    const uniqueId = generateUniqueId();
    const geometry = feature.getGeometry();
    const coordinates = transformCoordinates(geometry);
    const shapeProperties = getDefaultShapeProperties(geometryType);
    // Set feature properties
    feature.setProperties({
        type: geometryType,
        floorId: selectedKeys?.join(''),
        siteId: siteId,
        id: uniqueId,
        layerId: selectedLayerData?.layerId,
        shapeProperties,
    });
    // Create GeoJSON for saving
    const geojsonFeature = {
        type: 'Feature',
        properties: {
            type: geometryType,
            floorId: selectedKeys?.join(''),
            siteId: siteId,
            id: uniqueId,
            layerId: selectedLayerData?.layerId,
            shapeProperties,
        },
        geometry: {
            type: 'LineString',
            coordinates: coordinates,
        },
    };
    // Auto-save the shape
    await saveShapeWithErrorHandling(geojsonFeature, feature, socket);
};
// ==================== FEATURE MANAGEMENT UTILITIES ====================
// Find layer ID by layer name
export const findLayerIdByName = (layerName, floorLayerData) => {
    return floorLayerData?.find((layer) => layer?.name === layerName)?.layerId || null;
};
// Get all features from multiple layer refs filtered by layer ID
export const getAllFeaturesByLayerId = (layerRefs, layerId) => {
    return layerRefs
        .map((layerRef) => layerRef.current?.getSource()?.getFeatures() || [])
        .flat()
        .filter((feature) => feature.get('layerId') === layerId);
};
// Create invisible style for hiding features
export const createInvisibleStyle = () => {
    return new Style({
        fill: new Fill({
            color: 'rgba(0, 0, 0, 0)', // Fully transparent fill
        }),
        stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0)', // Fully transparent stroke
        }),
    });
};
// Hide features by layer name or selected layer
export const hideFeatures = (layerRefs, floorLayerData, selectedLayerData, originalStylesRef, layerName = null) => {
    let layerId = null;
    if (layerName) {
        layerId = findLayerIdByName(layerName, floorLayerData);
    }
    else {
        layerId = selectedLayerData?.layerId;
    }
    if (!layerId)
        return;
    const invisibleStyle = createInvisibleStyle();
    const allFeaturesToHide = getAllFeaturesByLayerId(layerRefs, layerId);
    if (allFeaturesToHide.length > 0) {
        allFeaturesToHide.forEach((feature) => {
            const featureId = feature.getId();
            // Store the original style if not already stored
            if (!originalStylesRef.current.find((entry) => entry.id === featureId)) {
                originalStylesRef.current.push({
                    id: featureId,
                    style: feature.getStyle(),
                });
            }
            // Apply the invisible style to hide the feature
            feature.setStyle(invisibleStyle);
        });
    }
};
// Unhide features by layer name or selected layer
export const unhideFeatures = (layerRefs, floorLayerData, selectedLayerData, originalStylesRef, layerName = null) => {
    let layerId = null;
    if (layerName) {
        layerId = findLayerIdByName(layerName, floorLayerData);
    }
    else {
        layerId = selectedLayerData?.layerId;
    }
    if (!layerId)
        return;
    const allFeaturesToUnhide = getAllFeaturesByLayerId(layerRefs, layerId);
    if (allFeaturesToUnhide.length > 0) {
        allFeaturesToUnhide.forEach((feature) => {
            const featureId = feature.getId();
            // Find the original style for this feature
            const originalStyleEntry = originalStylesRef.current.find((entry) => entry.id === featureId);
            if (originalStyleEntry) {
                feature.setStyle(originalStyleEntry.style); // Restore the original style
            }
        });
    }
};
// ==================== DELETE FEATURE UTILITIES ====================
// Remove route layer feature and associated points
export const removeRouteLayerFeature = (selectedFeatures, routeLayerRef, pointLayerRef, selectedLayerData, setRouteCollection, updatePointsToVertices) => {
    const source = routeLayerRef.current.getSource();
    const geometry = selectedFeatures.getGeometry();
    if (geometry.getType() !== 'LineString')
        return;
    const lineCoordinates = geometry.getCoordinates();
    source.removeFeature(selectedFeatures);
    // Remove corresponding vertex points from pointLayer
    const pointSource = pointLayerRef.current.getSource();
    const pointsToRemove = pointSource.getFeatures().filter((pointFeature) => {
        const [lng, lat] = toLonLat(pointFeature.getGeometry().getCoordinates());
        return lineCoordinates.some((coordinate) => {
            const [lineLng, lineLat] = toLonLat(coordinate);
            return lineLng === lng && lineLat === lat;
        });
    });
    pointsToRemove.forEach((point) => pointSource.removeFeature(point));
    // Update the route collection after deletion
    updatePointsToVertices(routeLayerRef.current.getSource().getFeatures(), pointLayerRef, selectedLayerData);
    const geoJsonRoute = getGeoJson(routeLayerRef.current.getSource());
    setRouteCollection(removeDuplicateFeatures(geoJsonRoute));
};
// Remove feature from outer wall layer
export const removeOuterWallFeature = (selectedFeatures, polygonLayerRef, socket, siteId, setSelectedFeatures) => {
    const source = polygonLayerRef.current.getSource();
    source.removeFeature(selectedFeatures);
    const { shapeId, floorId } = selectedFeatures?.values_ || {};
    socket.emit('DELETE_SHAPE', { siteId, shapeId, floorId });
    setSelectedFeatures(null);
};
// Remove feature from other layers
export const removeOtherLayerFeature = (selectedFeatures, polygonLayerRef, wallLayerRef, socket, siteId, setSelectedFeatures) => {
    const source = polygonLayerRef.current.getSource();
    const innerWallSource = wallLayerRef.current.getSource();
    source.removeFeature(selectedFeatures);
    innerWallSource.removeFeature(selectedFeatures);
    const { shapeId, floorId } = selectedFeatures?.values_ || {};
    socket.emit('DELETE_SHAPE', { siteId, shapeId, floorId });
    setSelectedFeatures(null);
};
// Main delete selected features function
export const deleteSelectedFeatures = (selectedFeatures, selectedLayerData, routeLayerRef, pointLayerRef, polygonLayerRef, wallLayerRef, socket, siteId, setSelectedFeatures, setRouteCollection, updatePointsToVertices) => {
    if (!selectedFeatures) {
        message.warning('Select some features to delete');
        return;
    }
    // Main logic
    if (selectedLayerData?.name === 'Route Layer') {
        removeRouteLayerFeature(selectedFeatures, routeLayerRef, pointLayerRef, selectedLayerData, setRouteCollection, updatePointsToVertices);
    }
    else if (selectedLayerData?.name === 'Outer Wall') {
        removeOuterWallFeature(selectedFeatures, polygonLayerRef, socket, siteId, setSelectedFeatures);
    }
    else {
        removeOtherLayerFeature(selectedFeatures, polygonLayerRef, wallLayerRef, socket, siteId, setSelectedFeatures);
    }
};
// ==================== SOCKET COMMUNICATION UTILITIES ====================
// Build site with socket communication
export const buildSite = (socket, siteId, totalSteps = 7, onComplete) => {
    const id = siteId;
    const type = 'site';
    const data = { id, type };
    const channel = `/topic/site/${id}`;
    socket.emit('SUBSCRIBE', channel, data);
    socket.emit('BUILD', siteId);
    socket.on('BUILD', (data) => {
        if (data && data?.data?.stage >= 0) {
            // Ensure step is valid
            const currentStep = data?.data?.stage;
            if (data?.data?.status === 'COMPLETED' && currentStep === totalSteps - 1) {
                message.success('Build completed successfully');
                socket.off('BUILD');
                if (onComplete)
                    onComplete();
            }
            if (data?.data?.status === 'FAILED') {
                message.error('Build failed');
                socket.off('BUILD');
                if (onComplete)
                    onComplete();
            }
        }
    });
};
// ==================== LAYER MANAGEMENT UTILITIES ====================
// Get layer data by name from floor layer data
export const getLayerDataByName = (layerName, floorLayerData) => {
    return floorLayerData?.find((layer) => layer?.name === layerName) || null;
};
// Check if layer allows specific geometry types
export const isLayerRestrictedForGeometry = (layerName) => {
    return layerName === 'Route Layer' || layerName === 'Outer Wall';
};
// ==================== TREE AND SELECTION UTILITIES ====================
// Extract floor data by key from building tree
export const getFloorDataByKey = (buildingTree, floorKey) => {
    for (const building of buildingTree) {
        for (const floor of building.children) {
            if (floor?.key === floorKey) {
                return floor?.floorData;
            }
        }
    }
    return null;
};
// Extract selected titles from building tree
export const getSelectedTitles = (selectedKeys, buildingTree, findTitle) => {
    return selectedKeys.map((key) => findTitle(key, buildingTree || []));
};
